export default "__VITE_ASSET__69622e0e__"